(function () {
  function trackAblyftGoal(eventName) {
    if (!eventName) return;

    window.ablyft = window.ablyft || [];
    window.ablyft.push({
      eventType: 'custom',
      eventName: eventName
    });
  }

  function initHoverPersistence(details) {
    if (details.dataset.mmHoverInit) return;
    details.dataset.mmHoverInit = '1';

    var summary = details.querySelector('summary');
    var closeTimer;

    function setExpanded(expanded) {
      details.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function open() {
      window.clearTimeout(closeTimer);
      var others = document.querySelectorAll('.nh-mm-item > details[open]');
      for (var i = 0; i < others.length; i++) {
        if (others[i] !== details) {
          others[i].removeAttribute('open');
          others[i].setAttribute('aria-expanded', 'false');
          var otherSummary = others[i].querySelector('summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
        }
      }
      details.setAttribute('open', '');
      setExpanded(true);
    }

    function close() {
      details.removeAttribute('open');
      setExpanded(false);
    }

    // The invisible bridge (::before on the panel) covers the gap between
    // nav row and panel; this small delay is only a safety net for grazing
    // the panel edges.
    function scheduleClose() {
      if (details.dataset.mmDragging) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(close, 150);
    }

    if (summary) {
      summary.addEventListener('click', function (event) {
        var href = summary.dataset.link;
        if (!href) return;
        event.preventDefault();
        window.location.href = href;
      });
    }

    details.addEventListener('mouseover', open);
    details.addEventListener('mouseleave', scheduleClose);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', function (event) {
      // relatedTarget is null when focus is dropped (e.g. a focused arrow
      // button becomes disabled) — only close when focus really moved to
      // an element outside the menu. Outside clicks are still handled by
      // the theme's document click listener and by mouseleave.
      if (event.relatedTarget && !details.contains(event.relatedTarget)) close();
    });
  }

  function initSlider(slider) {
    if (slider.dataset.mmInit) return;
    slider.dataset.mmInit = '1';

    var track = slider.querySelector('[data-mm-slider-track]');
    var bar = slider.querySelector('[data-mm-slider-bar]');
    var fill = slider.querySelector('[data-mm-slider-fill]');
    var arrows = slider.querySelector('[data-mm-slider-arrows]');
    var prevBtn = slider.querySelector('[data-mm-prev]');
    var nextBtn = slider.querySelector('[data-mm-next]');
    if (!track) return;

    var details = slider.closest('details');

    function setDragging(active) {
      if (!details) return;
      if (active) {
        details.dataset.mmDragging = '1';
      } else {
        delete details.dataset.mmDragging;
      }
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function updateFill() {
      var max = maxScroll();
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      if (fill) fill.style.width = Math.max(0, Math.min(1, ratio)) * 100 + '%';
      if (bar) bar.classList.toggle('is-hidden', max <= 1);
      if (arrows) arrows.classList.toggle('is-hidden', max <= 1);
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function scrollByPage(direction) {
      var page = Math.max(track.clientWidth * 0.8, 160);
      if (track.scrollBy) {
        track.scrollBy({ left: direction * page, behavior: 'smooth' });
      } else {
        track.scrollLeft += direction * page;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByPage(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByPage(1);
      });
    }

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    var activePointerId = null;

    // Links/images would otherwise hijack the drag as a native HTML drag,
    // which stops pointermove events and breaks drag-to-scroll.
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('pointerdown', function (e) {
      if (typeof e.button === 'number' && e.button !== 0) return;
      isDown = true;
      moved = false;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-grabbing');
      setDragging(true);
    });

    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        // Capture the pointer so the release never produces a click on a
        // product link and events keep flowing while dragging fast.
        if (track.setPointerCapture && activePointerId !== null) {
          try {
            track.setPointerCapture(activePointerId);
          } catch (err) {
            /* ignore */
          }
        }
      }
      track.scrollLeft = startScroll - dx;
      updateFill();
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      activePointerId = null;
      track.classList.remove('is-grabbing');
      setDragging(false);
    }

    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    track.addEventListener('scroll', updateFill, { passive: true });

    if (bar) {
      var barDown = false;

      function scrub(clientX) {
        var rect = bar.getBoundingClientRect();
        if (rect.width <= 0) return;
        var ratio = (clientX - rect.left) / rect.width;
        ratio = Math.max(0, Math.min(1, ratio));
        track.scrollLeft = maxScroll() * ratio;
        updateFill();
      }

      bar.addEventListener('pointerdown', function (e) {
        barDown = true;
        setDragging(true);
        scrub(e.clientX);
        e.preventDefault();
      });
      window.addEventListener('pointermove', function (e) {
        if (barDown) scrub(e.clientX);
      });
      window.addEventListener('pointerup', function () {
        if (!barDown) return;
        barDown = false;
        setDragging(false);
      });
    }

    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) requestAnimationFrame(updateFill);
      });
    }

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        updateFill();
      });
      ro.observe(track);
    }

    window.addEventListener('resize', updateFill);
    updateFill();
  }

  function initAll() {
    var details = document.querySelectorAll('.nh-mm-item > details');
    for (var d = 0; d < details.length; d++) initHoverPersistence(details[d]);

    var sliders = document.querySelectorAll('[data-mm-slider]');
    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
  }

  function initOpenTracking() {
    if (document.documentElement.dataset.nhMmOpenTracking) return;
    document.documentElement.dataset.nhMmOpenTracking = '1';

    // Gilt fuer Variante A UND B (beide nutzen <details> in .site-nav).
    // Drive-by-Hover zaehlt nicht: das Open-Goal feuert erst, wenn das
    // Panel 800ms ununterbrochen offen bleibt.
    var dwellTimers = new WeakMap();
    document.addEventListener('toggle', function (event) {
      var panel = event.target;
      if (!panel || panel.tagName !== 'DETAILS' || !panel.closest('.site-nav')) return;
      if (panel.closest('[data-header-mobile-menu]')) return;
      window.clearTimeout(dwellTimers.get(panel));
      if (panel.open) {
        dwellTimers.set(panel, window.setTimeout(function () {
          if (panel.open) {
            trackAblyftGoal('nh_desktop_menu_open');
          }
        }, 800));
      }
    }, true);
  }

  function initClickTracking() {
    if (document.documentElement.dataset.nhMmClickTracking) return;
    document.documentElement.dataset.nhMmClickTracking = '1';

    document.addEventListener('click', function (event) {
      var slide = event.target.closest('.nh-mm a.mm-slide');
      if (slide) {
        if (slide.classList.contains('mm-slide--category')) {
          trackAblyftGoal('nh_desktop_menu_category_click');
        } else {
          trackAblyftGoal('nh_desktop_menu_product_click');
        }
        return;
      }

      var cta = event.target.closest('.nh-mm a.nh-mm__cta, .nh-mm a.nh-mm-overview__promo');
      if (cta) {
        trackAblyftGoal('nh_desktop_menu_cta_click');
        return;
      }

      var controlLink = event.target.closest('.site-nav .megamenu a[href]');
      if (!controlLink || controlLink.closest('.nh-mm')) return;
      if (controlLink.closest('.aktion-wrapper')) {
        trackAblyftGoal('nh_desktop_menu_cta_click');
        return;
      }
      var href = controlLink.getAttribute('href') || '';
      if (href.indexOf('/products/') !== -1) {
        trackAblyftGoal('nh_desktop_menu_product_click');
      } else if (href.indexOf('/collections/') !== -1) {
        trackAblyftGoal('nh_desktop_menu_category_click');
      }
    });
  }

  initOpenTracking();
  initClickTracking();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders the header section; re-bind hover + sliders.
  document.addEventListener('shopify:section:load', initAll);
})();
